import React from "react";
import {SelectOption} from "@/types";

type Props = {
    options: SelectOption[];
    selected: string;
    mitsumori_iraijino_kibonoki_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

export const MitsumoriIraijinoKibonoki = ({options, selected, mitsumori_iraijino_kibonoki_error, setValue}: Props) => {
    return (
        <div className="form-flex">
            <div className="form-flex-txt">希望納期</div>
            <div className="form-flex-input">
                <div className={`form_mitsumori_iraijino_kibonoki form-flex-input-radio02${mitsumori_iraijino_kibonoki_error ? ' form-input-error' : ''}`}>
                    {options.map((option) => (
                        <label key={option.id}>
                            <input
                                type="radio"
                                name="mitsumori_iraijino_kibonoki"
                                value={option.id}
                                required
                                checked={selected === option.id}
                                onChange={() => setValue('mitsumori_iraijino_kibonoki', option.id)}
                            /> {option.name}
                        </label>
                    ))}
                </div>
                {mitsumori_iraijino_kibonoki_error &&
                    <div className="form-error-message">{mitsumori_iraijino_kibonoki_error}</div>}

            </div>
        </div>
    );
};
